export default "__VITE_ASSET__IRAVB$Wq__"